
import { Component, Prop, Emit, Vue } from 'vue-property-decorator'

@Component({})
export default class ConfirmationDialog extends Vue {
  @Prop({ default: false })
  model!: boolean

  @Prop({ default: '' })
  text!: string

  @Emit()
  confirm () {
  }

  @Emit()
  cancel () {
  }
}
